/**
 * Shared cream-theme tokens for the site chrome (nav + footer).
 * Pages used to each define their own PALETTE — these are the canonical values.
 */
export const PALETTE = {
  bg: "#F8F4EC",
  bgAlt: "#F2EBDC",
  ink: "#1a1a1a",
  ink2: "#3a3530",
  muted: "#5a5249",
  amber: "#C4823A",
  amberSoft: "#E8B458",
  line: "rgba(0,0,0,0.08)",
  card: "#FFFFFF",
  dark: "#171513",
};

export const FONT_BODY = "Barlow, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
export const FONT_DISPLAY = "'Instrument Serif', 'Cormorant Garamond', Georgia, serif";
export const FONT_MONO = "'JetBrains Mono', ui-monospace, monospace";

/** Canonical product IA — the same three entries on every page. */
export type ProductKey = "software" | "cobrain" | "services";

export const PRODUCTS: { key: ProductKey; label: string; to: string }[] = [
  { key: "software", label: "Eva", to: "/" },
  { key: "cobrain", label: "Company brain", to: "/cobrain" },
  { key: "services", label: "How it works", to: "/services" },
];